export default {
  "search.performance": "iglu:com.torrelabs/DiscoverySearchPerformance/jsonschema/4-0-0",
  "ContactInvited": "iglu:com.torrelabs/ContactInvited/jsonschema/1-0-0",
  "itemAdded": "iglu:com.torrelabs/HedaItemAdded/jsonschema/2-0-0",
  "pageNavigation": "iglu:com.torrelabs/HedaPageNavigation/jsonschema/1-0-3",
  "UserIdentified": "iglu:com.torrelabs/UserIdentified/jsonschema/1-0-0",
  "TrackingIdContext": "iglu:com.torrelabs/TrackingIdContext/jsonschema/2-0-0",
  "UserContext": "iglu:com.torrelabs/UserContext/jsonschema/1-0-1",
  "InteractionContext": "iglu:com.torrelabs/InteractionContext/jsonschema/3-0-1",
  "StrengthContext": "iglu:com.torrelabs/StrengthContext/jsonschema/1-0-1",
  "OpportunityResultActionPerformed": "iglu:com.torrelabs/OpportunityResultActionPerformed/jsonschema/1-0-0",
  "OpportunityContext": "iglu:com.torrelabs/OpportunityContext/jsonschema/3-1-1",
  "ApplicationStepEntered": "iglu:com.torrelabs/ApplicationStepEntered/jsonschema/1-0-0",
  "ApplicationActionPerformed": "iglu:com.torrelabs/ApplicationActionPerformed/jsonschema/1-0-0",
  "ApplicationSubmitted": "iglu:com.torrelabs/ApplicationSubmitted/jsonschema/1-0-0",
  "PipelineActionPerformed": "iglu:com.torrelabs/PipelineActionPerformed/jsonschema/1-0-0",
  "CandidateSummaryContext": "iglu:com.torrelabs/CandidateSummaryContext/jsonschema/3-0-3",
  "ReferrerTokenRequested": "iglu:com.torrelabs/ReferrerTokenRequested/jsonschema/1-0-0",
  "ReferrerTokenGenerated": "iglu:com.torrelabs/ReferrerTokenGenerated/jsonschema/1-0-0",
  "ReferrerTokenGeneratedFailed": "iglu:com.torrelabs/ReferrerTokenGeneratedFailed/jsonschema/1-0-0",
  "ABTestContext": "iglu:com.torrelabs/ABTestContext/jsonschema/1-0-0",
  "UserReferred": "iglu:com.torrelabs/UserReferred/jsonschema/1-0-0",
  "ReferrerFlowStarted": "iglu:com.torrelabs/ReferrerFlowStarted/jsonschema/1-0-0",
  "ReferrerDialogOpened": "iglu:com.torrelabs/ReferrerDialogOpened/jsonschema/1-0-0",
  "ReferrerContext": "iglu:com.torrelabs/ReferrerContext/jsonschema/4-0-0",
  "ServicesContext": "iglu:com.torrelabs/ServicesContext/jsonschema/1-0-0",
  "Notification": "iglu:com.torrelabs/Notification/jsonschema/1-0-0",
  "Meeting": "iglu:com.torrelabs/Meeting/jsonschema/2-0-0",
  "MatchingFactorContext": "iglu:com.torrelabs/MatchingFactor/jsonschema/2-0-0",
  "PersonContext": "iglu:com.torrelabs/Person/jsonschema/2-0-0"
} as { [key: string]: string };

export type TypeAheadAction = "start_search" | "keyboard_selection" | "mouse_selection" | "end_search" | "restart_search";
